import { useParams } from 'react-router-dom';
import { WavelightsContainer } from './styles';
import AlgorithmCalculation from '../components/AlgorithmCalculation';
import AlgorithmTable from '../components/AlgorithmTable';
import ResearchTable from '../components/ResearchTable';

const Waves = () => {
  const { id } = useParams();

  return (
    <WavelightsContainer>
      <AlgorithmCalculation id={id || ''} />
      <ResearchTable id={id || ''} />
      <AlgorithmTable id={id || ''} />
    </WavelightsContainer>
  );
};

export default Waves;
